// Ping leger pour la metrique "utilisateurs actifs du jour".
// Remplace l'ancien systeme de logs (collection Firestore "log", 4M+ docs) :
// au lieu d'ecrire un document par appel API, on signale une fois au chargement
// puis periodiquement -> 1 document par utilisateur et par jour cote backend.
// Best-effort : aucune erreur ne doit impacter l'application.
const sendHeartbeat = async (token, prefix) => {
  try {
    await fetch(prefix + "admin/heartbeat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (e) {
    // no-op
  }
};

export default sendHeartbeat;
